"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _default = exports["default"] = function _default(errors) {
  if (typeof errors === 'string') {
    return errors;
  }
  if (_typeof(errors) !== 'object') {
    throw new Error('Errors have wrong format');
  }
  var messages = [];
  for (var _i = 0, _Object$values = Object.values(errors); _i < _Object$values.length; _i++) {
    var error = _Object$values[_i];
    if (typeof error === 'string') {
      messages.push(error);
    } else {
      messages = messages.concat(error);
    }
  }
  return messages.join(', ');
};